import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routers.config";
import NProgress from "nprogress";
import auth from "@/mixin/auth.mixin";
import jwtDecode from "jwt-decode";
Vue.use(VueRouter);

NProgress.configure({ showSpinner: false });
const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});
const checkAuth = function (callback, refreshTo) {
    const that = router.app;
    let user = auth.data().auth.getCachedSession();
    let refreshToken = user.getRefreshToken().getToken();
    console.log("refreshToken: ", refreshToken);
    if (refreshToken) {
        that.$ls.set("refreshTo", refreshTo);
        auth.data().auth.refreshSession(refreshToken);
    } else {
        that.$ls.clear();
        callback();
    }
};
const node = process.env.VUE_APP_NOTE
const baseHostOrigin =
    node == "PRODUCT" ? process.env.VUE_APP_HOST_ORIGIN_PRODUCT :
    node == "STAGING" ? process.env.VUE_APP_HOST_ORIGIN_STAGING :
    node == "DEV" ? process.env.VUE_APP_HOST_ORIGIN_DEV :
    "http://localhost:8080"

router.beforeEach(async (to, from, next) => {
    NProgress.start();
    var that = router.app;
    if (window.location.origin != baseHostOrigin) {
        window.location.href = `${baseHostOrigin}${to.path}`
    }
    const Authorization = that.$ls.get("Authorization");
    const { query, path, params, name } = to;
    const refreshTo = { query, path, params, name };
    if (to.matched.some((record) => record.meta.requiresAuth)) {
        if (Authorization == null) {
            next({
                path: "/",
            });
        } else {
            let expireAt = jwtDecode(Authorization).exp;
            let currentTime = new Date().valueOf() / 1000;
            if (currentTime >= expireAt) {
                checkAuth(next, refreshTo);
            } else {
                next();
            }
        }
    } else {
        console.log("-----")
        if (window.location.origin != baseHostOrigin) {
            window.location.href = `${baseHostOrigin}${to.path}`
        }
        if (to.path == "/" && Authorization !== null) {
            let expireAt = jwtDecode(Authorization).exp;
            let currentTime = new Date().valueOf() / 1000;
            if (currentTime >= expireAt) {
                checkAuth(next, refreshTo);
            } else {
                next({
                    path: "/list-user",
                });
            }
        } else {
            next();
        }
    }
});
router.afterEach(() => {
    NProgress.done();
});

export default router;